import type { IconType } from '@innovamat/glimmer-icons';
import type { Material } from './materials';
import type { MomentContent } from './momentContent';
import type { BooleanElement, Item, PrepElement } from './prepr';
import type { Standard } from './standard';
import type { VideoChapterContent } from './videoChapter';

export type Moments = Item<Moment[]>;

export type Moment = {
  id: string;
  key_moment: BooleanElement;
  moment: PrepElement;
  title: PrepElement;
  video_chapter_content?: VideoChapterContent;
  summary?: PrepElement;
  moment_content?: MomentContent;
  material?: Material;
  standard?: Standard;
  recap?: PrepElement;
};

export const MomentTypes = {
  Takeoff: '1',
  Flight: '2',
  Landing: '3',
  Video: '4',
};

export const MOMENT_CONTENT_TYPES_TEXT = {
  '1': 'RegisterTip',
  '2': 'ClassManagementTip',
  '3': 'AssessmentTip',
  '4': 'AmpliationTip',
  '5': 'SupportTip',
  '6': 'SolutionsTip',
  '7': 'IndividualTask',
  '8': 'CoupleTask',
  '9': 'SmallTeamTast',
  '10': 'BigGroupTask',
  '11': 'PoolingTask',
  '12': 'IndividualRegistering',
  '13': 'CoupleRegistering',
  '14': 'SmallGroupRegistering',
  '15': 'BigGroupRegistering',
  '16': 'ShiftingAgrupation',
  '17': 'Observation',
};

export const MOMENT_CONTENT_TYPES_ICONS: Record<string, IconType> = {
  '1': 'EditIcon',
  '2': 'TouchIcon',
  '3': 'EvaluateIcon',
  '4': 'ExtensionIcon',
  '5': 'SuportIcon',
  '6': 'SolutionsIcon',
  '7': 'UserIcon',
  '8': 'UserPairsIcon',
  '9': 'LittlegroupIcon',
  '10': 'HugeGroupIcon',
  '11': 'ChatIcon',
  '12': 'UserRegisterIcon',
  '13': 'UserPairsRegisterIcon',
  '14': 'LittleGroupRegisterIcon',
  '15': 'RegisterHugeGroupIcon',
  '16': 'EvaluateIcon',
  '17': 'ChangingAgrupationIcon',
};
